<div #body class="detail-page__body">
  <app-quick-nav #quicknav class="detail-page__nav" [toc]="toc"></app-quick-nav>
  <app-airport-alert [airport]="airport"></app-airport-alert>
  <div class="airport-detail__before-overview">
    <app-edit-toggle *ngIf="isAirportManager; else nonManagerPlaceholder" class="editSlider"></app-edit-toggle>
    <app-airport-flight-deck-button *ngIf="editModeSet && isFlightDeckAdmin" [airport]="airport"></app-airport-flight-deck-button>
    <div class="airport-detail__faa-text">
      <p>All data is based on information provided by </p>
      <p>airport and business managers unless otherwise noted.</p>
    </div>
  </div>
  <div class="detail-page__content">
    <div class="detail-page__primary">
      <div class="scroll-spy-section detail-page__wrapper" id="overview">
        <app-airport-overview [airport]="airport" [isIsland]="isCaribbeanOrBahamasIsland" [isSubscribedToIslandGuide]="isSubscribedToIslandGuide"></app-airport-overview>
      </div>
      <div class="detail-page__main" *ngIf="isCaribbeanOrBahamasIsland">
        <app-open-x-adunit [adUnitId]="'/21794231495/directory/leaderboard'" [width]="728" [height]="90" [position]="2" [ident]="airport.faaId"></app-open-x-adunit>

        <div class="scroll-spy-section detail-page__wrapper" id="fbos">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text" *ngIf="sortedFBOs.length > 0; else noFBOPlaceholder">FBOs</h2>
              <button id="addFBOs"
                      mat-mini-fab
                      *ngIf="editModeSet && isFlightDeckAdmin"
                      (click)="openAddDialog('BUSINESS')">
                <mat-icon aria-label="Add FBO">add</mat-icon>
              </button>
            </div>
            <div class="section__body">
              <app-business-listing [businesses]="airport.businesses" [airport]="airport"></app-business-listing>
            </div>
          </div>
        </div>

        <div class="scroll-spy-section detail-page__wrapper" id="local">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text">Local Food/Lodging/Activities</h2>
            </div>
            <div class="section__body" *ngIf="isSubscribedToIslandGuide else buyIslandGuide">
              <app-local-panel [airport]="airport" [isIslandSource]="isCaribbeanOrBahamasIsland"></app-local-panel>
            </div>
          </div>
        </div>

        <app-open-x-adunit [adUnitId]="'/21794231495/directory/leaderboard'" [width]="728" [height]="90" [position]="3" [ident]="airport.faaId"></app-open-x-adunit>

        <div class="scroll-spy-section detail-page__wrapper" id="flyingclubs">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text">Flying Clubs</h2>
              <button id="addFlyingClubs"
                      mat-mini-fab
                      *ngIf="editModeSet && isFlightDeckAdmin"
                      (click)="openAddDialog('FLYING CLUB')">
                <mat-icon aria-label="Add Flying Club">add</mat-icon>
              </button>
            </div>
            <div class="section__body" *ngIf="isSubscribedToIslandGuide else buyIslandGuide">
              <app-flyingclub-listing [flyingClubs]="airport.flyingClubs"></app-flyingclub-listing>
            </div>
          </div>
        </div>

        <!-- commented out temporarily per Eric on 3/9/2018
        <div class=scroll-spy-section id="fees">
          <app-airport-fee-summary [businessSummaries]="businessesWithFees"></app-airport-fee-summary>
        </div> -->

        <div class="scroll-spy-section detail-page__wrapper" id="runways" *ngIf="isSubscribedToIslandGuide else runways">
          <app-runway-listing [airport]="airport" [isIslandSource]="isCaribbeanOrBahamasIsland"></app-runway-listing>

          <app-remarks class="airport-detail__full-width" [airport]="airport"></app-remarks>

          <app-noise-abatement [airport]="airport"></app-noise-abatement>
        </div>

        <app-open-x-adunit [adUnitId]="'/21794231495/directory/leaderboard'" [width]="728" [height]="90" [position]="4" [ident]="airport.faaId"></app-open-x-adunit>

        <div class="scroll-spy-section detail-page__wrapper" id="procedures" *ngIf="isSubscribedToIslandGuide else procedures">
          <app-procedure-listing class="section procedure-listing" [identifier]="airport.identifier"
                                 [procedurePack]="airport.terminalProcedures"></app-procedure-listing>
        </div>

        <div class="scroll-spy-section detail-page__wrapper" id="operations">
          <div class="section">
            <div class="section__header">
              <mat-icon (click)="openEditOperationsDialog(airport)" *ngIf="editModeSet && isFlightDeckAdmin && isCaribbeanOrBahamasIsland"
                        class="edit-icon" mat-tooltip="Edit Operations" aria-label="Button that opens popover that allows you to edit operations">edit</mat-icon>
              <h2 class="section__header-text">Operations &amp; More Information</h2>
            </div>
            <div class="section__body" *ngIf="isSubscribedToIslandGuide else buyIslandGuide">
              <app-operations [airport]="airport"></app-operations>
            </div>
          </div>
        </div>

        <div class="scroll-spy-section detail-page__wrapper" id="comms">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text">Communications Card</h2>
              <button id="addComms" (click)="openAddCommsDialog()" mat-mini-fab *ngIf="editModeSet && isSubscribedToIslandGuide">
                <mat-icon aria-label="Add Navaid">add</mat-icon>
              </button>
            </div>
            <div class="section__body" *ngIf="isSubscribedToIslandGuide else buyIslandGuide">
              <app-communication-card [identifier]="airport.identifier"
                                      [flightComms]="airport.flightComms"
                                      [isIslandSource]="isCaribbeanOrBahamasIsland">
              </app-communication-card>
            </div>
          </div>

          <div class="section" *ngIf="airport.navaids">
            <div class="section__header">
              <h2 class="section__header-text">Navaids</h2>
              <button id="addNavaids" (click)="openAddNavaidDialog()" mat-mini-fab *ngIf="editModeSet && isFlightDeckAdmin && isSubscribedToIslandGuide">
                <mat-icon aria-label="Add Navaid">add</mat-icon>
              </button>
            </div>
            <div class="section__body" *ngIf="isSubscribedToIslandGuide else buyIslandGuide">
              <app-navaid-listing [navaids]="airport.navaids" [identifier]="airport.identifier"></app-navaid-listing>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section__header">
            <h2 class="section__header-text">Services</h2>
          </div>
          <div class="section__body" *ngIf="isSubscribedToIslandGuide else buyIslandGuide">
            <app-services [airport]="airport" [isIslandSource]="isCaribbeanOrBahamasIsland"></app-services>
          </div>
        </div>

        <div class="section" *ngIf="airport.activity">
          <div class="section__header">
            <h2 class="section__header-text">Aircraft &amp; Activity</h2>
          </div>
          <div class="section__body" *ngIf="isSubscribedToIslandGuide else buyIslandGuide">
            <app-airport-activity [activity]="airport.activity"></app-airport-activity>
          </div>
        </div>

        <div class="scroll-spy-section detail-page__wrapper" id="wx" *ngIf="isSubscribedToIslandGuide else webcamMetarsTafs">
          <app-airport-webcams [airport]="airport" class="airport-detail__full-width" ></app-airport-webcams>

          <div class="detail-page__wrapper">
            <app-metar-section [identifier]="airport.identifier" [latlon]="airport.location" [translated]="true"
                               class="section section--half-width"></app-metar-section>

            <app-taf-section [identifier]="airport.identifier" [latlon]="airport.location" [translated]="true"
                             class="section section--half-width"></app-taf-section>
          </div>
        </div>

        <div class="section">
          <div class="section__header">
            <h2 class="section__header-text">Contact Addresses</h2>
          </div>
          <div class="section__body" *ngIf="isSubscribedToIslandGuide else buyIslandGuide">
            <app-contact-listing [contacts]="airport.contacts" [remarks]="airport.airportComments"></app-contact-listing>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-page__rail">
      <div class="detail-page__rail-content">

        <div class="section__right-rail">
          <div class="section__header">
            <h2 class="section__header-text">Airport Reviews</h2>
          </div>
          <div class="section__body" *ngIf="isSubscribedToIslandGuide else buyIslandGuide">
            <app-reviews [airport]="airport" [business]=null (reloadThisEntity)="onReloadAirport($event)"></app-reviews>
          </div>
        </div>
      </div>

      <app-travel-articles [airportIdent]="airport.faaId"></app-travel-articles>

    </div>
  </div>
</div>

<ng-template #noFBOPlaceholder>
  <h2 class="section__header-text">FBOs and Other Businesses</h2>
</ng-template>

<ng-template #nonManagerPlaceholder>
  <p> </p>
</ng-template>

<ng-template #buyIslandGuide>
  <a mat-button href="https://www.aopa.org/travel/international-travel/bahamas-and-caribbean-pilots-guides"
     class="aopa-mat-btn aopa-mat-btn--filled">
    Buy Island Guide
  </a>
</ng-template>

<ng-template #webcamMetarsTafs>
  <div class="section">
    <div class="section__header">
      <h2 class="section__header-text">Subcribe to access webcam, METAR, and TAFS information</h2>
    </div>
    <a mat-button href="#"
       class="aopa-mat-btn aopa-mat-btn--filled">
      Buy Island Guide
    </a>
  </div>
</ng-template>

<ng-template #runways>
  <div class="section">
    <div class="section__header">
      <h2 class="section__header-text">Subcribe to access runway, remarks, and noise abatement information</h2>
    </div>
    <a mat-button href="#"
       class="aopa-mat-btn aopa-mat-btn--filled">
      Buy Island Guide
    </a>
  </div>
</ng-template>

<ng-template #procedures>
  <div class="section">
    <div class="section__header">
      <h2 class="section__header-text">Subcribe to access instrument procedure information</h2>
    </div>
    <a mat-button href="#"
       class="aopa-mat-btn aopa-mat-btn--filled">
      Buy Island Guide
    </a>
  </div>
</ng-template>
